import React, { Component } from 'react';
import Isvg from 'react-inlinesvg';

export default class Sidemenu extends Component {
    render() {
        const { isOpen, toggle } = this.props;
        const classes = ['sidemenu'];
        if (isOpen) {
            classes.push('is-open');
        }
        return (
            <aside className={classes.join(' ')}>
                <div className="close-layer" onClick={toggle} />
                <div className="sidemenu--inner">
                    <div className="close-icon" onClick={toggle}>
                        <Isvg src="../../svg/cancel.svg" />
                    </div>
                    {this.props.children}
                </div>
            </aside>
        );
    }
}
